angular.module('BGEHeroes.directives.Vege', [])

.directive('vege', ['loaderSvcVege', '$location', 'Gateway', '$rootScope', function (loaderSvcVege, $location, Gateway, $rootScope) {
       "use strict";
       return {
           restrict : 'EAC',
           replace : true,
           scope :{
			    onProxyMessage: '&'
           },
           template: "<canvas></canvas>",
           link: function (scope, element, attribute) {
			   
               var w, h, lepes;
			   
			   var hatter1, hatter2, bar, logo, tovabb, ujra;
			   
			   var STAGE_WIDTH, STAGE_HEIGHT, STAGE_ASPECT_RATIO, scope;
			   
			   var visszaallitas;
			   var kattintva;
			   
			   var ablak_nagy, ablakszoveg, tippszoveg;
							
			   var palyaszam, pontszam;
			   
			   var indulopontszam;
			   var eletekszama;

			   var myrate = Gateway.framerate;
			   
			   var hozzavalok = {};
			   
			   var tipp;

			   var tipppos = [1960-216-50, 950];
			   var ujrapos = [1960-216-50-250, 950];
			   var tovabbpos = [1960-216-300-250, 950];
			   
			   var uzenet;		   
			   var lock;
			   var megoldva;
			   
			   var idoszovegek = ["8:00", "8:15", "8:30", "8:45", "9:00", "9:15", "9:30", "9:45", "10:00", "10:15", "10:30", "10:45", "11:00", "11:15",  "11:30",  "11:45",  "12:00", "12:15",  "12:30",  "12:45" ];
			   var idopos = [100, 100, 100, 0];
			   
			   var ugyintezoszovegek = ["1. ügyintéző",  "2. ügyintéző", "3. ügyintéző", "4. ügyintéző", "5. ügyintéző"];
			   var ugyintezopos = [100, 200, 0, 100];
			   
			   var idobeosztasszovegek = ["Időbeosztás"];
			   var idobeosztaspos = [50, 50, 0, 0];
			   
			   var szovegek = {
					tipp: "1. megoldás: Az adott ügyintéző idejét használjuk ki minél jobban: az elsőt feltöltjük a lehető leghosszabb ügyekkel, majd a másodikat és így tovább. Ez rögtön eredményre vezet!\n\n2. megoldás: A mohó algoritmus gondolatvilágával: a legkorábbtól szabad ügyintéző megkapja a hátralévő leghosszabb ügyet (LPT algoritmus).",
					start: "Az adott ügyintézések megfelelő helyre húzásával készítsd el az öt ügyintéző egy lehetséges munkabeosztását!",
					kesz: "Gratulálunk, a feladat megoldása sikeres volt!",
					nem: "Sajnos a feladat megoldása sikertelen volt!"
			   };
			   
			   //Színezés a hossz szerint
			   var szinek = ["blue", "blue", "blue", "red", "yellow", "white", "black", "green", "orange", "pink", "pink", "coral" ];
			   //Húzható feladatok
			   var feladatok = [2, 2, 3, 3, 3, 4, 4, 4, 5, 5, 6, 6, 7, 8, 8, 10];
			   var huzhatok = [];
			   
			   var kontenerek = [];
			   
			   lepes=0;
									
               drawGame();
			   
               function drawGame() {
                   if (scope.stage) {
                       scope.stage.autoClear = true;
                       scope.stage.removeAllChildren();
                       scope.stage.update();
                   } else {
                       scope.stage = new createjs.Stage(element[0]);
                   }
                   w = scope.stage.canvas.width = STAGE_WIDTH = 1920;
                   h = scope.stage.canvas.height = STAGE_HEIGHT = 1080;
				   
					loaderSvcVege.getLoader().addEventListener("complete", handleComplete);
					loaderSvcVege.loadAssets();

					/////////////////////////////////////////
					STAGE_ASPECT_RATIO = STAGE_WIDTH / STAGE_HEIGHT;
					var containerWidth = window.innerWidth;
					var containerHeight = window.innerHeight;
					var brratio = containerWidth/containerHeight;
					if (STAGE_ASPECT_RATIO>brratio){
						//A Stage magasabb. Teljes szélesség, a magasságot kell korlátozni.
						scope.stage.canvas.width = containerWidth;
						scope.stage.canvas.height = containerWidth / ref;
						   
					}else{
						//A Stage szélesebb. Teljes magasság, a szélességet kell korlátozni.
						scope.stage.canvas.width = containerHeight * ref;
						scope.stage.canvas.height = containerHeight;
					}
					// scale stage to fit canvas
					var scalex = scope.stage.canvas.width / STAGE_WIDTH;
					var scaley = scope.stage.canvas.height / STAGE_HEIGHT;
					scope.stage.scaleX = scalex;
					scope.stage.scaleY = scaley;
					scope.stage.update();					
					/////////////////////////////////////////////
				   
               }


               function handleComplete() {
				   	
					lock = false;
					
					Gateway.pontkezdo = Gateway.pont;
					storagesave();
					
				   	//Gateway.pont += 100;
					//Gateway.palya += 1;					

					visszaallitas = 0;
				   
					hatter1 = addtostage ("hatter1", 0, 0, w, h);
					
					tippszoveg = addtext( w/2, h/2-100, szovegek["tipp"], "70px RobotoRegular", "#000", 1500, "center", 1);				
					tippszoveg.alpha = 0;
					
					ablak_nagy = addsprite("ablak_nagy", 0, 0, w, h, true );
					
					if (Gateway.pontkezdo>1400){
						ablakszoveg = addtext( w/2, h/2-100, "A játék véget ért! Gratulálunk a megszerzett pontszámhoz. Nagyon jó teljesítmény. Kattintson a képernyőre az újrakezdéshez!", "70px RobotoRegular", "#000", 1500, "center", 1);				
					}else{
						ablakszoveg = addtext( w/2, h/2-100, "A játék véget ért! Gratulálunk a megszerzett pontszámhoz, bár vannak még hiányosságok. Kattintson a képernyőre az újrakezdéshez!", "70px RobotoRegular", "#000", 1500, "center", 1);
					}
					
					scope.stage.update();				
					ablakszoveg.y = h/2-ablakszoveg.getBounds().height/2;
					scope.stage.update();
					
					uzenet = addtext( w/2, h-100, szovegek["start"], "40px RobotoRegular", "#000", 1400, "center", 1);
					uzenet.alpha = 0;
					
					logo = addsprite ("logo", 0, 50);
					logo.addEventListener("mousedown", fomenube);
					
					bar = addsprite ("bar", w-50-577, 50);

					createjs.Ticker.timingMode = createjs.Ticker.TIMEOUT;
					createjs.Ticker.framerate = myrate;
					createjs.Ticker.addEventListener("tick", tick);
				    createjs.Ticker.addEventListener("tick", createjs.Tween);
				   
					scope.onProxyMessage( {command: 'ready', param: ''} );
					
					updatepalyaszam();
					updatepontszam();

					scope.stage.update();
										
				   	createjs.Touch.enable(scope.stage);
					scope.stage.enableMouseOver(10);
					scope.stage.mouseMoveOutside = true;
					
					scope.stage.addEventListener("stagemousedown", handleComplete2);
					
			   }


               function handleComplete2() {
				   
				   
				   Gateway.currentstep = 1;
					Gateway.pont = 0;
					Gateway.pontkezdo = 0;
					Gateway.palya = 0;
				   
				   storagesave();
				   closeandjump(1);
				   return;
				   
				    if (Gateway.isios){
					   Gateway.audio.powerup.play();
				   }else{
						createjs.Sound.play("powerup");
				   }
				   				   
					scope.stage.removeEventListener("stagemousedown", handleComplete2);
				   	ablak_nagy.alpha=0;
					ablakszoveg.alpha=0;
					
					//Gomb rajzolása
					ujra = addsprite ( "ujra", ujrapos[0], ujrapos[1] );
					ujra.addEventListener("mousedown", kattintas);
					ujra.alpha = 0;

					tovabb = addsprite ( "tovabb", tovabbpos[0], tovabbpos[1] );
					tovabb.addEventListener("mousedown", kattintas);
					tovabb.alpha = 0;


					tipp = addsprite ( "tipp", tipppos[0], tipppos[1] );
					tipp.addEventListener("mousedown", kattintas);
					tipp.alpha = 1;

					szovegkijelzes ("start");
					scope.stage.update();
					
					/*
					var myGraphics = new createjs.Graphics();
					myGraphics.beginStroke("red").beginFill("blue").drawRect(0, 0, 100, 50);
					stage.addChild(myGraphics);
					
					var uzenet = new createjs.Text("abc", "bold 16px Courier", "#fff");
					
					var container = new createjs.Container();
					stage.addChild(container);
					
					container.addChild(myGraphics, uzenet);
					container.x = 100;
					container.y = 100;
					*/
					
			   }
			   
			   
			   function sugotmutat (){
				   
				    scope.stage.setChildIndex( ablak_nagy, scope.stage.getNumChildren()-1);
				    ablak_nagy.alpha=1;
				   
				    scope.stage.setChildIndex( tippszoveg, scope.stage.getNumChildren()-1);
				   
				   
					tippszoveg.y = h/2-tippszoveg.getBounds().height/2;
					scope.stage.update();
					
					tippszoveg.alpha=1;
				    scope.stage.addEventListener("stagemousedown", sugokikapcs);
				   
			   }
			   
			   function sugokikapcs (){
				    scope.stage.removeEventListener("stagemousedown", sugokikapcs);
				   	ablak_nagy.alpha=0;
					tippszoveg.alpha=0;
			   }
			   
			   function addtostage (id, x, y, w, h){
					var shape;
					shape = new createjs.Shape();
					shape.graphics.beginBitmapFill(loaderSvcVege.getResult(id)).drawRect(x, y, w, h);
					scope.stage.addChild(shape);
					return shape;
			   }
			   
			   function addsprite (id, x, y){
				   var bitmap;
				   bitmap = new createjs.Bitmap(loaderSvcVege.getResult(id));
				   bitmap.x = x;
				   bitmap.y = y;
				   scope.stage.addChild(bitmap);
				   return bitmap;
			   }
			   
			   	function storagesave(){
				   
				   	var storage = window.localStorage;

					storage.setItem("currentstep", Gateway.currentstep );
					storage.setItem("palya", Gateway.palya);
					storage.setItem("pont", Gateway.pont);
					storage.setItem("pontkezdo", Gateway.pontkezdo );
				   
			   }
			   
			   function fomenube(){
				   
				   	$rootScope.loading = true;					
			   		createjs.Ticker.reset();
					scope.stage.removeAllChildren();
					scope.stage.removeAllEventListeners();
					loaderSvcVege.getLoader().removeEventListener("complete", handleComplete);
				   
				   scope.onProxyMessage( {command: 'goto', param: "/fomenu"} );
			   }
			   
			   
			   function szovegkijelzes (id){
				 
				    visszaallitas = Gateway.szovegvisszaallas;
					uzenet.text = szovegek[id];
				    uzenet.alpha = 1;
			   }
			   

			   function addtext (xpos, ypos, text, font, mycolor, mywidth, myalign, myalpha ){
				   var myshape;

					var offsetx = 0;
					var offsety = 0;
				
				   if (xpos<0) xpos=w+xpos;
				   if (ypos<0) ypos=h+ypos;
				   
				   myshape = new createjs.Text(text, font, mycolor);
				   myshape.x = xpos + offsetx;
				   myshape.y = ypos + offsety ;
				   myshape.name = text;
				   
				   scope.stage.addChild(myshape);

				   myshape.lineWidth=mywidth;
				   myshape.textAlign=myalign;
				   myshape.alpha=myalpha;
				   
				   return myshape;
			   }
			   
			    function addsprite (id, x, y){
				   var bitmap;
				   bitmap = new createjs.Bitmap(loaderSvcVege.getResult(id));
				   bitmap.name = id;
				   bitmap.x = x;
				   bitmap.y = y;
				   scope.stage.addChild(bitmap);
				   return bitmap;
			   }			   
			   
				function updatepalyaszam (){
					if (palyaszam) scope.stage.removeChild(palyaszam);
					palyaszam = addtext( w-50-420, 75+Gateway.fontdiff, Gateway.palya + "." , "35px RobotoBold", "#FFFFFF", 100, "left", true);
				}

				function updatepontszam (){
					if (pontszam) scope.stage.removeChild(pontszam);
					pontszam = addtext( w-50-110, 75+Gateway.fontdiff, Gateway.pont , "35px RobotoBold", "#FFFFFF", 100, "left", true);
				}
				

			   
			   function tick(event) {

					if (!lock){
						if (visszaallitas>0){
							visszaallitas--;
						}else{
							uzenet.alpha = 0;
						}
					}
					
                   scope.stage.update(event);
               }

				function ujrarajzol(){
					
					console.log ("Újrarajzolás");
				
				}
				
				function reset(){
					
					ujrarajzol();
					
				}
				

			   function kattintas (event){
				   

					var nev = event.target.name;

					if (nev == "ujra"){
						reset();
						return;
					}

					if (nev == "tovabb"){
						
						Gateway.pont += 100;
						Gateway.palya += 1;					
						storagesave();
						
						if (Gateway.isios){
							Gateway.audio.drainmagic.play();
						}else{
							createjs.Sound.play("drainmagic");
						}
						closeandjump();
						return;
					}

					if (nev == "tipp"){
						sugotmutat();
						return;
					}
					
					if (lock)return
					
				   if (Gateway.isios){
					   Gateway.audio.swish.play();
				   }else{
					   createjs.Sound.play("swish");
				   }


					
			   }
			   
			   function closeandjump(step){
					
					$rootScope.loading = true;					
			   		createjs.Ticker.reset();
					scope.stage.removeAllChildren();
					scope.stage.removeAllEventListeners();
					loaderSvcVege.getLoader().removeEventListener("complete", handleComplete);
					
					var ide;
					
					if (step === undefined){
						ide=Gateway.steps[++Gateway.currentstep];
						if (ide === undefined){
							Gateway.currentstep = 0;
							ide=Gateway.steps[Gateway.currentstep];
						}
					}else{
						Gateway.currentstep = step;
						ide=Gateway.steps[Gateway.currentstep];
					}
					
					scope.onProxyMessage( {command: 'goto', param: ide} );
					
			   }
			   
           }
       }
   }]);